import React, { FunctionComponent } from 'react';
import { isLoggedIn } from '../../utils/auth';
import { navigate } from '@reach/router';

const navigateTo = (route: string, options: any) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathSegments = currentPath.split('/');
    // Keep only the segments up to and including "pay-rent"
    const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
    navigate(`${basePath}/${route}`, {
        state: options
    });
}

export const PrivateRoutes: FunctionComponent<any> = ({
    component: Component,
    ...rest
}) => {
    const {
        path
    } = rest;
    if (!isLoggedIn() && !location.pathname.includes('login')) {
        const state = {
            path
        }
        navigateTo('login', state)
        return null;
    }
    return (
        <>
            <Component {...rest} />
        </>
    )
}